import { render, staticRenderFns } from "./FiscalReports.vue?vue&type=template&id=cf668648&scoped=true"
import script from "./FiscalReports.vue?vue&type=script&lang=js"
export * from "./FiscalReports.vue?vue&type=script&lang=js"
import style0 from "./FiscalReports.vue?vue&type=style&index=0&id=cf668648&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf668648",
  null
  
)

export default component.exports